export default {
  recapTitle: {
    id: 'search_recap_title',
    defaultMessage: 'Your search:',
  },
  filterSortLabel: {
    id: 'product_filter_sort_label',
    defaultMessage: 'Sort by',
  },
  landingNavigationSeoTitle: {
    id: 'landing_navigation_seo_title',
    defaultMessage: 'Categories',
  },
  months: {
    id: 'landing_months',
    defaultMessage: 'months',
  },
  totalProduct: {
    id: 'landing_page_filters_products_new_plural',
    defaultMessage: `{total, plural,
      one {# product}
      other {# products}
    }`,
  },
  filter: {
    id: 'landing_page_filter',
    defaultMessage: 'Filter',
  },
  sort: {
    id: 'landing_page_sort',
    defaultMessage: 'Sort',
  },
}
